
export class EntCompany {
  id: number | null = null;
  companyName: string | null = null;
  totalFertilizer: number | null = null;
  contacts: Contact[] = [];
  editedTime: string | null = null;
  createdTime: string | null = null;
}

export class Contact {
  id: number | null = null;
  company: string | null = null;
  contactName: string | null = null;
  phone: string | null = null;
  email: string | null = null;
  key: number | null = null;
}